var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var disque100QueryKeys = {
    root: ["disque100"],
    data: function (query, filters) {
        return __spreadArray(__spreadArray([], disque100QueryKeys.root, true), ["data", query, filters], false);
    },
    kpis: function (subtabId, filters) {
        return __spreadArray(__spreadArray([], disque100QueryKeys.root, true), ["kpis", subtabId, filters], false);
    },
};
